var _excluded = ["className", "title", "value", "type", "useGroup", "getItemKey", "onChange", "onDelete", "onClearAll", "onItemClick", "onSort", "onValueChange", "renderPanelItem", "showClearAll", "disabled", "disableAnimation", "readonly", "emptyText", "sort", "draggable", "showNum", "style", "listViewerHeight", "rowHeight"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useEffect, useRef } from 'react';
import { usePrevProp, useRefCallback, useRefGetter, getElementPosition, useScrollTo } from '@okee-uikit/react-hooks';
import { classnames } from '@okee-uikit/react-utils';
import { useLocale, usePrefixCls, useDirection } from '@okee-uikit/react-config';
import { HamburgerButton } from '../../common/icons';
import { CASCADER_PANEL_COLUMN_LIST_HEIGHT, CASCADER_PANEL_COLUMN_TITLE_HEIGHT, CASCADER_PANEL_HEIGHT } from '../../models/cascader/lib/Cascader';
import { Empty } from '../empty';
import { Link } from '../link';
import { List } from '../list';
import { Tag } from '../tag';
export function ListViewer(props) {
  var empty = useLocale('list-viewer.empty');
  var locale = useLocale('select.clear');

  var className = props.className,
      title = props.title,
      _props$value = props.value,
      value = _props$value === void 0 ? [] : _props$value,
      _props$type = props.type,
      type = _props$type === void 0 ? 'tag' : _props$type,
      _props$useGroup = props.useGroup,
      useGroup = _props$useGroup === void 0 ? false : _props$useGroup,
      getItemKey = props.getItemKey,
      onChange = props.onChange,
      onDelete = props.onDelete,
      onClearAll = props.onClearAll,
      onItemClick = props.onItemClick,
      onSort = props.onSort,
      onValueChange = props.onValueChange,
      renderPanelItem = props.renderPanelItem,
      _props$showClearAll = props.showClearAll,
      showClearAll = _props$showClearAll === void 0 ? true : _props$showClearAll,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      disableAnimation = props.disableAnimation,
      _props$readonly = props.readonly,
      readonly = _props$readonly === void 0 ? false : _props$readonly,
      _props$emptyText = props.emptyText,
      emptyText = _props$emptyText === void 0 ? empty : _props$emptyText,
      _props$sort = props.sort,
      sort = _props$sort === void 0 ? false : _props$sort,
      _props$draggable = props.draggable,
      draggable = _props$draggable === void 0 ? sort : _props$draggable,
      _props$showNum = props.showNum,
      showNum = _props$showNum === void 0 ? false : _props$showNum,
      style = props.style,
      listViewerHeight = props.listViewerHeight,
      rowHeight = props.rowHeight,
      extra = _objectWithoutProperties(props, _excluded);

  var direction = useDirection();
  var triggerCls = usePrefixCls('viewer-trigger');
  var listBox = useRef(null);
  var cls = classnames(usePrefixCls('viewer'), className);

  var listViewerStyle = _objectSpread(_objectSpread({}, style), {}, {
    height: listViewerHeight !== null && listViewerHeight !== void 0 ? listViewerHeight : CASCADER_PANEL_HEIGHT
  });

  var listInnerHeight = listViewerHeight ? listViewerHeight - CASCADER_PANEL_COLUMN_TITLE_HEIGHT - 2 : CASCADER_PANEL_COLUMN_LIST_HEIGHT;
  var titleCls = usePrefixCls('viewer-title');
  var titleLeft = usePrefixCls('viewer-title-left', {
    rtl: direction === 'rtl'
  });
  var clearAllCls = usePrefixCls('viewer-title-clear-all', {
    rtl: direction === 'rtl'
  });
  var listCls = usePrefixCls('viewer-list', {
    empty: !value.length
  });
  var innerCls = usePrefixCls('viewer-inner');
  var listItemCls = usePrefixCls('viewer-list-item');
  var valueGetter = useRefGetter(value);
  var disabledGetter = useRefGetter(disabled);
  var readonlyGetter = useRefGetter(readonly);
  var onDeleteCallback = useRefCallback(onDelete);
  var onClearAllCallback = useRefCallback(onClearAll);
  var onSortCallback = useRefCallback(onSort);
  var onChangeCallback = useRefCallback(onChange);
  var onValueChangeCallback = useRefCallback(onValueChange);
  var onItemClickCallback = useRefCallback(onItemClick);
  var handleTagClose = useCallback(function (data) {
    var itemValue = data.value,
        _data$disabled = data.disabled,
        itemDisabled = _data$disabled === void 0 ? false : _data$disabled,
        _data$readonly = data.readonly,
        itemReadonly = _data$readonly === void 0 ? false : _data$readonly;

    if (itemDisabled || itemReadonly || disabledGetter() || readonlyGetter()) {
      return;
    }

    var newVal = valueGetter().filter(function (item) {
      return item.value !== itemValue;
    });
    onDeleteCallback(data);
    onChangeCallback(newVal);
    onValueChangeCallback(newVal);
  }, []);
  var handleClearAll = useCallback(function () {
    if (readonlyGetter() || disabledGetter() || !valueGetter().length) {
      return;
    }

    var newVal = valueGetter().filter(function (item) {
      return item.disabled || item.readonly;
    });
    onClearAllCallback();
    onChangeCallback(newVal);
    onValueChangeCallback(newVal);
  }, []);
  var handleSort = useCallback(function (list) {
    onSortCallback(list);
    onChangeCallback(list);
    onValueChangeCallback(list);
  }, []);
  var prev = usePrevProp(value)[1];

  var _useScrollTo = useScrollTo(listBox, 'top', function () {
    return listBox.current ? getElementPosition(listBox.current).height : 0;
  }, 150, function () {
    return prev.length < value.length;
  }),
      startScroll = _useScrollTo.startScroll;

  useEffect(function () {
    startScroll();
  });

  var renderItem = function renderItem(item) {
    var label = item.label,
        itemValue = item.value,
        _item$disabled = item.disabled,
        itemDisabled = _item$disabled === void 0 ? false : _item$disabled,
        _item$readonly = item.readonly,
        itemReadonly = _item$readonly === void 0 ? false : _item$readonly;
    var closeable = !(itemDisabled || itemReadonly || disabled || readonly);
    return React.createElement(Tag, {
      block: true,
      fill: true,
      className: listItemCls,
      closeable: closeable,
      key: String(itemValue),
      onClose: function onClose() {
        return handleTagClose(item);
      }
    }, draggable && React.createElement("span", {
      draggable: true
    }, React.createElement(HamburgerButton, {
      className: triggerCls
    })), renderPanelItem ? renderPanelItem(item) : label);
  };

  var renderList = function renderList() {
    if (!value.length) {
      return React.createElement(Empty, {
        content: emptyText
      });
    }

    return React.createElement(List, {
      height: listInnerHeight,
      disableAnimation: disableAnimation,
      draggable: draggable,
      trigger: triggerCls,
      datasource: value,
      getItemKey: getItemKey,
      renderItem: renderItem,
      onItemClick: onItemClickCallback,
      onValueChange: handleSort,
      rowHeight: rowHeight
    });
  };

  return React.createElement("div", _objectSpread({
    className: cls,
    style: listViewerStyle
  }, extra), React.createElement("div", {
    className: titleCls
  }, React.createElement("div", {
    className: titleLeft
  }, title, showNum ? "(".concat(value.length, ")") : null), showClearAll && React.createElement(Link, {
    className: clearAllCls,
    onClick: handleClearAll,
    disabled: disabled || value.every(function (item) {
      return item.disabled || item.readonly;
    })
  }, locale)), React.createElement("div", {
    ref: listBox,
    className: innerCls
  }, React.createElement("div", {
    className: listCls,
    style: {
      padding: 0
    }
  }, renderList())));
}